var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Node.ts";
//TODO применить предикаты на все опросы типов в Explorer
export var isEntity = function isEntity(node) {
  return node.type === 'Entity';
};
export var isAssembly = function isAssembly(node) {
  return node.type === 'Assembly';
};
export var isCategory = function isCategory(node) {
  return node.type === 'Category';
};
export var isItemNode = function isItemNode(node) {
  return isEntity(node) || isAssembly(node) || isCategory(node);
};